import { useCallback } from 'react';
import useModal from 'components/common/Modal/useModal';
import { ModalComponentGenerator, ModalComponentType } from 'components/common/Modal/ModalComponentGenerator';

export const useNumberPickerCommand = () => {
    const [, { openModal, setModalComponents }] = useModal();

    const execute = useCallback(async () => {
        try {
            const component = ModalComponentGenerator.generate(ModalComponentType.NumberPicker);
            setModalComponents(component);
            openModal();
        } catch (e) {
            console.error('NumberPickerCommand execute error', e);
        }
    }, [openModal, setModalComponents]);

    return { execute };
};
